<a [href]="getPublicationDetailLink()" class="no-decor">
  <h2 class="font-sm font-bold pointer margin-0">{{ (publication.title ? publication.title : defaultTitle) | truncate: 90 }}</h2>
</a>
<h3 class="font-xxs font-regular margin-y-2" *ngIf="self">Last edited on {{ publication.updated_at | date }}</h3>
<h3 class="font-xxs font-regular margin-y-2" *ngIf="!self">Published on {{ publication.updated_at | date }}</h3>
